import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "column q-my-md tw-bg-gray-100 q-pa-md tw-rounded-md" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "text-red" }
const _hoisted_4 = {
  key: 1,
  class: "text-h6"
}
const _hoisted_5 = {
  key: 2,
  class: "column"
}
const _hoisted_6 = { class: "text-h6" }
const _hoisted_7 = { key: 8 }
const _hoisted_8 = { class: "text-h6" }
const _hoisted_9 = { key: 9 }
const _hoisted_10 = { class: "text-h6" }
const _hoisted_11 = { key: 10 }
const _hoisted_12 = { class: "text-h6" }
const _hoisted_13 = { key: 11 }
const _hoisted_14 = { class: "text-h6" }
const _hoisted_15 = { key: 12 }
const _hoisted_16 = { class: "text-h6" }
const _hoisted_17 = { class: "text-h3" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_19 = { class: "tw-flex tw-align-items-end" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "tw-flex-grow" }, null, -1)
const _hoisted_21 = {
  key: 20,
  class: "row"
}
const _hoisted_22 = { class: "row" }
const _hoisted_23 = {
  key: 23,
  class: "tw-whitespace-pre-wrap"
}
const _hoisted_24 = { key: 24 }
const _hoisted_25 = {
  key: 0,
  class: "column"
}
const _hoisted_26 = { class: "tw-bg-green-100 tw-rounded-md q-my-sm q-pa-sm tw-border tw-cursor-move" }
const _hoisted_27 = ["src"]
const _hoisted_28 = { key: 30 }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("a", { role: "button" }, "Info", -1)
const _hoisted_30 = ["innerHTML"]
const _hoisted_31 = { key: 32 }
const _hoisted_32 = { key: 33 }
const _hoisted_33 = { class: "tw-text-red-600" }

import { useCanvas } from '../../composables/recaps/useCanvas'
import { useDisplayLogic } from '../../composables/recaps/useDisplayLogic'
import { useLogic } from '../../composables/recaps/useLogic'
import { Field, FieldType, Formula, LocaleStrings, LogicGroup, Validation } from '../../types/recap'
import { ref, computed, watch, onMounted, Ref, inject, nextTick } from 'vue'
import Draggable from 'vuedraggable'
import PhotoUploader from '../forms/inputs/PhotoUploader.vue'
import { quantityReasonCodes } from '../../data/quantityReasonCodes'
import { storeToRefs } from 'pinia'
import { useTaskProfiles } from '../../store/useTaskProfiles'
import { useUserStore } from '../../store/useUserStore'
import { useRecapHelpers } from '../../composables/recaps/useRecapHelpers'
import { parseBool } from '../../utils'
import { useCodes } from '../../store/useCodes'
import { useSharedRecap, recapTaskData } from '../../composables/recaps/useRecap'
import { Nullish } from '../../types/utility'

// Props/Emits
type FieldOption = {
  label: string
  value: string
  numericEquivalent?: number | null
  stringEquivalent?: string
  index?: number
}

export default /*#__PURE__*/_defineComponent({
  __name: 'RecapField',
  props: {
    field: {},
    repeatingIndex: {}
  },
  emits: ["value-change"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props
const emit = __emit

const fieldLoaded = ref(false)

const {
  recapId,
  recapType,
  taskOrStoreId,
  recapLanguage,
  recapDefinition,
  triggerAllConditions,
  getInitialValue,
} = useSharedRecap()

// Task Data
const { getTaskByTaskId } = useTaskProfiles()
const task = computed(() => {
  if (recapType.value === 'task') {
    return getTaskByTaskId(taskOrStoreId.value)
  }
  return undefined
})
const singleImageUploader = ref<InstanceType<typeof PhotoUploader> | null>(null)
const multiImageUploader = ref<InstanceType<typeof PhotoUploader> | null>(null)
watch(taskOrStoreId, () => {
  ;(singleImageUploader.value as any)?.clearPhotos()
  ;(multiImageUploader.value as any)?.clearPhotos()
})
const adQuantity = computed(() =>
  task.value && task.value.ad_quantity ? task.value.ad_quantity : null
)
const quantityReasonCodeError = ref<string | null>(null)

// RAI Code
const raiCodeLocal = ref<string | Nullish>(null)

// Languages
const fieldName = computed(() => {
  return props.field.field.name_l10n[recapLanguage.value] || props.field.field.name
})
const fieldNotes = computed(() => {
  return props.field.field.notes_l10n[recapLanguage.value] || props.field.field.notes
})
const fieldInfoText = computed(() => {
  return (
    props.field.field.info_disclosure_text_l10n[recapLanguage.value] ||
    props.field.field.info_disclosure_text
  )
})
function getOptionText(option: { label: { [key in keyof LocaleStrings]: string }; value: any }) {
  return option.label[recapLanguage.value] || option.label['en_US']
}

// RAI Reason Code Specific Get Value
function getRaiReasonCodeValue(option: {
  label: { [key in keyof LocaleStrings]: string }
  value: any
}) {
  return option.value
}

// Display Logic
const { shouldBeHidden, handleAllDisplayLogic } = useDisplayLogic(
  recapId.value,
  taskOrStoreId,
  recapType
)
const isVisible = ref(true)
const errors = ref<string[]>([])
const fieldType = computed<FieldType>(() => props.field.field.defined_as)
const shouldDisplayName = computed(
  () =>
    fieldType.value !== 'FIELD_YES_NO' &&
    fieldType.value !== 'FIELD_SELECT' &&
    fieldType.value !== 'FIELD_SELECT_RADIO' &&
    fieldType.value !== 'FIELD_MULTISELECT' &&
    fieldType.value !== 'FIELD_SUBSECTION' &&
    fieldType.value !== 'FIELD_DISPLAY_TEXT' &&
    fieldType.value !== 'FIELD_RAI_CODE' &&
    fieldType.value !== 'FIELD_RAI_REASON_CODE' &&
    fieldType.value !== 'FIELD_IMAGE_REASON_CODE' &&
    fieldType.value !== 'FIELD_IMAGE_REASON_CODE_CUSTOM'
)
const shouldDisplayInfoText = ref(false)

handleDisplayLogicForImageReasonCode()
watch(raiCodeLocal, () => {
  handleDisplayLogicForImageReasonCode()
})

function handleDisplayLogicForImageReasonCode() {
  if (props.field.field.defined_as === 'FIELD_IMAGE_REASON_CODE') {
    if (!raiCodeLocal.value) {
      isVisible.value = false
      return
    }
    const { shouldDisplayImageQuestion } = useRecapHelpers()
    isVisible.value = shouldDisplayImageQuestion(task.value, raiCodeLocal.value)
  }
}

// Options
const options = computed(() => {
  if (props.field.field.task_property === 'placementInstructionSequence') {
    const keys = ['placement_instruction1', 'placement_instruction2', 'placement_instruction3']
    const placementOptions = keys
      .map((key, index) => {
        const instruction = task.value ? task.value[key] : null
        if (instruction) {
          return {
            label: `${index + 1} - ${instruction}`,
            value: `${index + 1}`,
            numericEquivalent: index + 1,
            index,
          }
        }
        return null
      })
      .filter((opt) => !!opt) as FieldOption[]
    if (!placementOptions.length) {
      const isTestingRecap = inject('testingRecap', false)
      if (isTestingRecap) {
        placementOptions.push({
          label: 'Placeholder Instruction for Testing',
          value: '1',
          numericEquivalent: 1,
          index: 0,
        })
      }
    }
    return placementOptions
  } else if (props.field.field.task_property === 'quantityReasonCode') {
    return quantityReasonCodes
  } else if (props.field.field.options && !(props.field.field.options instanceof Array)) {
    const optionValues = Object.keys(props.field.field.options)
    let filteredSortedLabeledOptions = optionValues
      .filter((opt) => parseBool((props.field.field.options as any)[opt].active))
      .sort((opt1: any, opt2: any) => {
        try {
          const opt1Order = parseInt((props.field.field.options as any)[opt1].display_order)
          const opt2Order = parseInt((props.field.field.options as any)[opt2].display_order)
          if (opt1Order < opt2Order) {
            return -1
          }
          return 1
        } catch (e) {
          return -1
        }
      })
      .map((value: any, index: number) => ({
        label:
          ((props.field.field.options as any)[value] &&
            (props.field.field.options as any)[value].name_l10n &&
            recapLanguage.value &&
            (props.field.field.options as any)[value].name_l10n[recapLanguage.value]) ||
          (props.field.field.options as any)[value].name,
        value: value as string,
        numericEquivalent: (props.field.field.options as any)[value].numeric_equivalent,
        stringEquivalent: (props.field.field.options as any)[value].string_equivalent,
        index,
      }))

    if (props.field.field.defined_as === 'FIELD_RAI_CODE') {
      filteredSortedLabeledOptions = filteredSortedLabeledOptions.filter((opt) => {
        const raiCodes = (recapDefinition.value?.available_rai_codes ?? [])
          .filter((rai: any) => {
            if (useUserStore().loggedInWithSwitchTo) {
              return true
            }
            return parseBool(rai.visible_to_reps)
          })
          .map((rai: any) => String(rai.id))
        if (!raiCodes || !raiCodes.length) {
          // We don't have a list of available RAI codes
          // This can happen if the task is a merch task
          // Display the default options if they exist
          if (props.field.default_options && props.field.default_options.length) {
            return props.field.default_options
              ? props.field.default_options
                  .map((defopt) => defopt.option_value)
                  .includes(opt.stringEquivalent)
              : false
          }
          // If we don't have default options either, just display all RAI codes
          return true
        }
        // We have available RAI codes, so filter down to those
        return raiCodes.includes(String(opt.stringEquivalent))
      })
    }
    return filteredSortedLabeledOptions
  }
  return []
})
const filteredOptions = ref<FieldOption[]>(options.value as any)
watch(options, () => ((filteredOptions.value as any) = options.value))
watch(filteredOptions, () => {
  // If the field is a ranked order field,
  // make sure the value gets updated with the new order when it changes
  const anyIndexOutOfOrder = filteredOptions.value.filter((option, index) => option.index !== index)
  if (anyIndexOutOfOrder.length && props.field.field.defined_as === 'FIELD_RANK') {
    filteredOptions.value = filteredOptions.value.map((option, index) => ({
      ...option,
      index,
    }))
    value.value = filteredOptions.value.map((option) => option.value)
  }
})

// RAI Reason Code Values
const raiReasonCodes = ref<FieldOption[]>([])
watch(raiCodeLocal, () => {
  if (raiCodeLocal.value) {
    const { raiReasonCodeOptions } = storeToRefs(useCodes())
    raiReasonCodes.value =
      (raiReasonCodeOptions.value[raiCodeLocal.value as any] as unknown as
        | FieldOption[]
        | undefined) || []
  } else {
    raiReasonCodes.value = []
  }
})
const displayRaiReasonCodes = computed(() =>
  (fieldType as unknown as string) === 'FIELD_RAI_REASON_CODE'
    ? !!raiReasonCodes.value.length
    : true
)
if (props.field.field.defined_as === 'FIELD_RAI_REASON_CODE') {
  watch(raiReasonCodes, () => {
    if (!raiReasonCodes.value.length) {
      isVisible.value = false
    } else {
      isVisible.value = true
    }
  })
}

// Value Logic
const value = ref<any[] | boolean | string | number | null>(null)
const secondValue = ref<string | null>(null) // Only used for the Duration field
const totalMinutes = computed(() => {
  // Only used for the Duration field
  if (props.field.field.defined_as === 'FIELD_DURATION') {
    return +(value.value || 0) * 60 + +(secondValue.value || 0)
  }
  return null
})
watch(value, () => {
  const { isValidValue } = useLogic(null, [])
  if (isValidValue(value.value, secondValue.value, fieldType.value)) {
    handleAdQuantityLogic()
    emit('value-change', getValue())
    dispatchTaskPropertyEvent()
    errors.value.splice(0, errors.value.length)
  } else {
    value.value = null
  }
})
watch(secondValue, () => {
  const { isValidValue } = useLogic(null, [])
  if (isValidValue(value.value, secondValue.value, fieldType.value)) {
    emit('value-change', getValue())
    dispatchTaskPropertyEvent()
  } else {
    secondValue.value = null
  }
})
watch(isVisible, () => {
  // Rerun logic if this field is no longer visible.
  // This also ensures that hidden task property values are wiped.
  emit('value-change', getValue())
  dispatchTaskPropertyEvent()
})

// Ad Quantity Installed & Quantity Reason Code Logic
const adsInstalledLocal = ref<number | Nullish>(recapTaskData.value.ads_installed)
watch(
  recapTaskData,
  () => {
    // Handle any Neptune logic surrounding task data
    if (adsInstalledLocal.value !== recapTaskData.value.ads_installed) {
      adsInstalledLocal.value = recapTaskData.value.ads_installed
      if (props.field.field.task_property === 'quantityReasonCode') {
        value.value = null
      }
    }
    if (raiCodeLocal.value !== recapTaskData.value.rai_code) {
      raiCodeLocal.value = recapTaskData.value.rai_code
      if (props.field.field.defined_as === 'FIELD_RAI_REASON_CODE') {
        value.value = null
      }
    }
  },
  { deep: true }
)
const displayAdQuantity = computed(() => {
  if (props.field.field.task_property !== 'adsInstalled') {
    return true
  }
  let adQuantity = null
  try {
    adQuantity =
      props.field.field.task_property === 'adsInstalled'
        ? parseInt(task.value?.ad_quantity as string)
        : null
  } catch (e) {
    adQuantity = null
  }
  const codes: any[] = ((recapDefinition.value?.active_rai_codes ?? []) as any[]).filter((code) =>
    parseBool(code.success)
  )

  return adQuantity && adQuantity > 1 && props.field.field.task_property === 'adsInstalled'
    ? codes.map((code) => code.code).includes(raiCodeLocal.value as string)
    : false
})
watch(displayAdQuantity, () => {
  if (props.field.field.task_property === 'adsInstalled') {
    value.value = null
  }
})
const displayQuantityReasonCode = computed(() =>
  props.field.field.task_property === 'quantityReasonCode'
    ? !!(
        filteredOptions.value &&
        filteredOptions.value.length &&
        task.value &&
        task.value.ad_quantity &&
        adsInstalledLocal.value !== null &&
        adsInstalledLocal.value !== undefined &&
        adsInstalledLocal.value > -1 &&
        adsInstalledLocal.value < parseInt(task.value.ad_quantity as string)
      )
    : true
)
function handleAdQuantityLogic() {
  if (value.value && props.field.field.task_property === 'adsInstalled') {
    try {
      const parsedVal = parseInt(value.value as string)
      const parsedAdQty = parseInt(task.value?.ad_quantity as string)
      if (parsedAdQty) {
        if (parsedVal > parsedAdQty) {
          value.value = null
          adsInstalledLocal.value = null
          quantityReasonCodeError.value =
            'Bad Value: Cannot be greater than the expected ad quantity'
        } else if (parsedVal < 0) {
          value.value = null
          adsInstalledLocal.value = null
          quantityReasonCodeError.value = 'Bad Value: Cannot be less than 0'
        } else if (parsedVal === 0) {
          value.value = null
          adsInstalledLocal.value = null
          quantityReasonCodeError.value =
            'Bad Value: Please revisit RAI response if no ads were able to be installed'
        } else {
          quantityReasonCodeError.value = null
          value.value = parsedVal
          adsInstalledLocal.value = parsedVal
        }
      } else {
        value.value = null
        adsInstalledLocal.value = null
      }
    } catch (e) {
      value.value = null
      adsInstalledLocal.value = null
      quantityReasonCodeError.value = 'Bad Value: Must be a number'
    }
  }
}

// Specifically for image capture fields
const fileCount = ref<number>(0)
function allFilesRemoved() {
  value.value = null
  fileCount.value = 0
}
function fileAdded(data: { num: number }) {
  value.value = `${data.num} IMAGES UPLOADED`
  fileCount.value = data.num
}

// Canvas Logic
const signaturePad = ref<HTMLCanvasElement | null>(null)
const { setupCanvas, canvasValue, resetCanvas } = useCanvas(signaturePad)
watch(canvasValue, () => {
  value.value = canvasValue.value
})

// Exposed Functions
function getValue() {
  if (
    !isVisible.value ||
    shouldBeHidden.value ||
    !displayRaiReasonCodes.value ||
    !displayAdQuantity.value ||
    !displayQuantityReasonCode.value
  ) {
    // If the field isn't visible, act like it's null
    // so logic conditions will function properly
    return null
  }

  // Otherwise, get the value
  return getValueRaw()
}
function getValueRaw() {
  // Grabs the current value regardless of visibility
  if (secondValue.value) {
    // Only used for the Duration field
    let sum = 0
    if (value.value) {
      sum += +value.value * 60
    }
    return (sum + +secondValue.value).toString()
  } else if (props.field.field.defined_as === 'FIELD_RANK') {
    // We want the order of the filtered values
    return filteredOptions.value
  }
  return value.value
}
function getTaskProperty(): string | null {
  return props.field.field.task_property
}
function getDisplayRaiReasonCodes(): boolean {
  return displayRaiReasonCodes.value
}
function getDisplayAdQuantity(): boolean {
  return displayAdQuantity.value
}
function getDisplayQuantityReasonCode(): boolean {
  return displayQuantityReasonCode.value
}
function getFormula(): Formula | null {
  return props.field.field.formula
}
function getFormulaValue(): Ref<any[] | boolean | string | number | null> {
  return value
}
function getFieldId(): string {
  return props.field.id
}
function getEventsCustomId(): string {
  return props.field.events_custom_id
}
function getFieldType(): FieldType {
  return props.field.field.defined_as
}
function getFieldTypeId(): string {
  return props.field.field.type
}
function getIsVisible(): boolean {
  return isVisible.value
}
function getOptions() {
  return {
    options: options.value,
    filteredOptionsRef: filteredOptions,
    resetValue: () => (value.value = []),
  }
}
function getLogicGroups(): LogicGroup[] {
  return props.field.logic_groups
}
function getValidations(): Validation[] {
  return props.field.validations
}
// We're typing these functions as an `any` or `any[]` since this is actually a reference to another `RecapField.vue`
function runLogic(selfRef: any, dependenceRefs: any[]) {
  const { checkLogicConditions, runLogicModifiers } = useLogic(selfRef, dependenceRefs)
  isVisible.value = checkLogicConditions(props.repeatingIndex)
  runLogicModifiers(props.repeatingIndex)
}
function runValidation(selfRef: any, dependenceRefs: any[]): number {
  const { checkValidation } = useLogic(selfRef, dependenceRefs)
  errors.value = checkValidation(props.repeatingIndex)
  return errors.value.length
}
function getRepeatingIndex() {
  return props.repeatingIndex
}
__expose({
  shouldBeHidden,
  getValue,
  getValueRaw,
  getTaskProperty,
  getFormula,
  getFormulaValue,
  getFieldId,
  getEventsCustomId,
  getFieldType,
  getFieldTypeId,
  getIsVisible,
  getDisplayRaiReasonCodes,
  getDisplayAdQuantity,
  getDisplayQuantityReasonCode,
  getOptions,
  getLogicGroups,
  getValidations,
  runLogic,
  runValidation,
  getRepeatingIndex,
})

watch(triggerAllConditions, () => {
  if (triggerAllConditions.value) {
    triggerAllConditions.value = false
    emit('value-change', getValue())
    dispatchTaskPropertyEvent()
  }
})

function dispatchTaskPropertyEvent() {
  if (props.field.field.task_property) {
    const { getTaskDataKeyForTaskProperty } = useRecapHelpers()
    const propertyKey = getTaskDataKeyForTaskProperty(props.field.field.task_property)
    if (propertyKey) {
      let emitValue = null
      if (props.field.field.defined_as === 'FIELD_RAI_CODE') {
        const currOption = (options.value as FieldOption[]).find(
          (opt) => opt.value.toString() === value.value?.toString()
        )
        if (currOption) {
          const active_rai_codes = recapDefinition.value?.active_rai_codes
          if (!active_rai_codes || !active_rai_codes.length) {
            emitValue = null
          } else {
            emitValue =
              active_rai_codes.find(
                (rai_code: any) =>
                  rai_code.id?.toString() === currOption.stringEquivalent?.toString()
              )?.code ?? null
          }
          if (emitValue && emitValue === '0') {
            // Manually switch the completed RAI code to `000` if needed
            emitValue = '000'
          }
        }
      } else {
        emitValue = getValue()
      }
      if (
        emitValue &&
        ['ads_installed', 'bundles_added', 'pieces_remaining', 'quantity_installed'].includes(
          propertyKey
        )
      ) {
        // Cast the value to a number if necessary
        emitValue = parseInt(emitValue)
      }
      recapTaskData.value[propertyKey] = emitValue
    }
  }
}

async function runInitialLogic() {
  emit('value-change', getValue())
  if (recapType.value === 'task') {
    dispatchTaskPropertyEvent()
  }
  await nextTick()
  await nextTick()
}
onMounted(async () => {
  // Sets up the signature pad if there is one
  setupCanvas()

  // Get any existing values if there's an existing recap
  const { initialValue, initialSecondValue, imageCount } = await getInitialValue(
    props.field.id,
    props.field.field.defined_as,
    props.field.field.default_value
  )
  value.value = initialValue
  secondValue.value = initialSecondValue
  fileCount.value = imageCount

  // Run initial logic
  await runInitialLogic()

  // If the field is the RAI reason code, ensure the value is set
  // It would have been wiped if we had an existing response loaded
  if (props.field.field.defined_as === 'FIELD_RAI_REASON_CODE') {
    value.value = initialValue
    await runInitialLogic()
  }

  // Run Display Logic
  handleAllDisplayLogic(props.field)

  await nextTick()

  fieldLoaded.value = true
})

return (_ctx: any,_cache: any) => {
  const _component_q_skeleton = _resolveComponent("q-skeleton")!
  const _component_q_radio = _resolveComponent("q-radio")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_option_group = _resolveComponent("q-option-group")!
  const _component_q_select = _resolveComponent("q-select")!
  const _component_q_date = _resolveComponent("q-date")!
  const _component_q_time = _resolveComponent("q-time")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_checkbox = _resolveComponent("q-checkbox")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!fieldLoaded.value)
      ? (_openBlock(), _createBlock(_component_q_skeleton, { key: 0 }))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          (errors.value && errors.value.length)
            ? (_openBlock(), _createElementBlock("ul", _hoisted_2, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(errors.value, (error) => {
                  return (_openBlock(), _createElementBlock("li", { key: error }, [
                    _createElementVNode("strong", _hoisted_3, _toDisplayString(error), 1)
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          (shouldDisplayName.value)
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(fieldName.value), 1))
            : _createCommentVNode("", true),
          (fieldType.value === 'FIELD_YES_NO')
            ? (_openBlock(), _createElementBlock("label", _hoisted_5, [
                _createElementVNode("span", _hoisted_6, _toDisplayString(fieldName.value), 1),
                _createVNode(_component_q_radio, {
                  modelValue: (value.value as any),
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (((value.value as any)) = $event)),
                  val: (true as any),
                  label: "Yes"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_q_radio, {
                  modelValue: (value.value as any),
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (((value.value as any)) = $event)),
                  val: (false as any),
                  label: "No"
                }, null, 8, ["modelValue"])
              ]))
            : _createCommentVNode("", true),
          (fieldType.value === 'FIELD_INTEGER')
            ? (_openBlock(), _createBlock(_component_q_input, {
                key: 3,
                outlined: "",
                modelValue: (value.value as any),
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (((value.value as any)) = $event)),
                type: "number",
                label: fieldName.value
              }, null, 8, ["modelValue", "label"]))
            : _createCommentVNode("", true),
          (fieldType.value === 'FIELD_TEXT')
            ? (_openBlock(), _createBlock(_component_q_input, {
                key: 4,
                outlined: "",
                modelValue: (value.value as any),
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (((value.value as any)) = $event)),
                label: fieldName.value
              }, null, 8, ["modelValue", "label"]))
            : _createCommentVNode("", true),
          (fieldType.value === 'FIELD_FLOAT1')
            ? (_openBlock(), _createBlock(_component_q_input, {
                key: 5,
                outlined: "",
                modelValue: (value.value as any),
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (((value.value as any)) = $event)),
                type: "number",
                label: fieldName.value
              }, null, 8, ["modelValue", "label"]))
            : _createCommentVNode("", true),
          (fieldType.value === 'FIELD_FLOAT2')
            ? (_openBlock(), _createBlock(_component_q_input, {
                key: 6,
                outlined: "",
                modelValue: (value.value as any),
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (((value.value as any)) = $event)),
                type: "number",
                label: fieldName.value
              }, null, 8, ["modelValue", "label"]))
            : _createCommentVNode("", true),
          (fieldType.value === 'FIELD_MONEY')
            ? (_openBlock(), _createBlock(_component_q_input, {
                key: 7,
                outlined: "",
                modelValue: (value.value as any),
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (((value.value as any)) = $event)),
                label: fieldName.value
              }, {
                prepend: _withCtx(() => [
                  _createVNode(_component_q_icon, { name: "las la-dollar-sign" })
                ]),
                _: 1
              }, 8, ["modelValue", "label"]))
            : _createCommentVNode("", true),
          (fieldType.value === 'FIELD_SELECT_RADIO')
            ? (_openBlock(), _createElementBlock("label", _hoisted_7, [
                _createElementVNode("span", _hoisted_8, _toDisplayString(fieldName.value), 1),
                _createVNode(_component_q_option_group, {
                  modelValue: value.value,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((value).value = $event)),
                  options: filteredOptions.value,
                  type: "radio",
                  label: fieldName.value
                }, null, 8, ["modelValue", "options", "label"])
              ]))
            : _createCommentVNode("", true),
          (
          fieldType.value === 'FIELD_SELECT' ||
          fieldType.value === 'FIELD_IMAGE_REASON_CODE' ||
          fieldType.value === 'FIELD_IMAGE_REASON_CODE_CUSTOM'
        )
            ? (_openBlock(), _createElementBlock("label", _hoisted_9, [
                _createElementVNode("span", _hoisted_10, _toDisplayString(fieldName.value), 1),
                (filteredOptions.value.length < 7)
                  ? (_openBlock(), _createBlock(_component_q_option_group, {
                      key: 0,
                      modelValue: value.value,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((value).value = $event)),
                      options: filteredOptions.value,
                      type: "radio",
                      label: fieldName.value
                    }, null, 8, ["modelValue", "options", "label"]))
                  : (_openBlock(), _createBlock(_component_q_select, {
                      key: 1,
                      modelValue: value.value,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((value).value = $event)),
                      "option-label": "label",
                      "option-value": "value",
                      options: filteredOptions.value,
                      "emit-value": "",
                      "map-options": ""
                    }, null, 8, ["modelValue", "options"]))
              ]))
            : _createCommentVNode("", true),
          (fieldType.value === 'FIELD_MULTISELECT')
            ? (_openBlock(), _createElementBlock("label", _hoisted_11, [
                _createElementVNode("span", _hoisted_12, _toDisplayString(fieldName.value), 1),
                (filteredOptions.value.length < 7)
                  ? (_openBlock(), _createBlock(_component_q_option_group, {
                      key: 0,
                      modelValue: value.value,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((value).value = $event)),
                      "option-value": (opt) => opt.value,
                      options: filteredOptions.value,
                      type: "checkbox",
                      label: fieldName.value
                    }, null, 8, ["modelValue", "option-value", "options", "label"]))
                  : (_openBlock(), _createBlock(_component_q_select, {
                      key: 1,
                      modelValue: value.value,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((value).value = $event)),
                      "option-label": "label",
                      "option-value": "value",
                      options: filteredOptions.value,
                      "emit-value": "",
                      "map-options": "",
                      multiple: ""
                    }, null, 8, ["modelValue", "options"]))
              ]))
            : _createCommentVNode("", true),
          (fieldType.value === 'FIELD_RAI_CODE')
            ? (_openBlock(), _createElementBlock("label", _hoisted_13, [
                _createElementVNode("span", _hoisted_14, _toDisplayString(fieldName.value), 1),
                (filteredOptions.value.length < 7)
                  ? (_openBlock(), _createBlock(_component_q_option_group, {
                      key: 0,
                      modelValue: value.value,
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((value).value = $event)),
                      options: filteredOptions.value,
                      type: "radio"
                    }, null, 8, ["modelValue", "options"]))
                  : (_openBlock(), _createBlock(_component_q_select, {
                      key: 1,
                      modelValue: value.value,
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((value).value = $event)),
                      "option-label": "label",
                      "option-value": "value",
                      options: filteredOptions.value,
                      "emit-value": "",
                      "map-options": ""
                    }, null, 8, ["modelValue", "options"]))
              ]))
            : _createCommentVNode("", true),
          (fieldType.value === 'FIELD_RAI_REASON_CODE')
            ? (_openBlock(), _createElementBlock("label", _hoisted_15, [
                _createElementVNode("span", _hoisted_16, _toDisplayString(fieldName.value), 1),
                (raiReasonCodes.value.length < 7)
                  ? (_openBlock(), _createBlock(_component_q_option_group, {
                      key: 0,
                      modelValue: value.value,
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((value).value = $event)),
                      options: raiReasonCodes.value,
                      type: "radio",
                      label: fieldName.value
                    }, {
                      label: _withCtx((opt) => [
                        _createElementVNode("span", null, _toDisplayString((opt.label as any)[_unref(recapLanguage)] || (opt.label as any)['en_US']), 1)
                      ]),
                      _: 1
                    }, 8, ["modelValue", "options", "label"]))
                  : (_openBlock(), _createBlock(_component_q_select, {
                      key: 1,
                      modelValue: value.value,
                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((value).value = $event)),
                      "option-label": getOptionText,
                      "option-value": getRaiReasonCodeValue,
                      options: raiReasonCodes.value,
                      "emit-value": "",
                      "map-options": ""
                    }, null, 8, ["modelValue", "options"]))
              ]))
            : _createCommentVNode("", true),
          (fieldType.value === 'FIELD_DATE')
            ? (_openBlock(), _createBlock(_component_q_date, {
                key: 13,
                minimal: "",
                modelValue: value.value,
                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((value).value = $event))
              }, null, 8, ["modelValue"]))
            : _createCommentVNode("", true),
          (fieldType.value === 'FIELD_SUBSECTION')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 14 }, [
                _createElementVNode("h3", _hoisted_17, _toDisplayString(fieldName.value), 1),
                _hoisted_18
              ], 64))
            : _createCommentVNode("", true),
          (fieldType.value === 'FIELD_TEXTAREA')
            ? (_openBlock(), _createBlock(_component_q_input, {
                key: 15,
                modelValue: (value.value as any),
                "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (((value.value as any)) = $event)),
                type: "textarea"
              }, null, 8, ["modelValue"]))
            : _createCommentVNode("", true),
          (fieldType.value === 'FIELD_TOTAL')
            ? (_openBlock(), _createBlock(_component_q_input, {
                key: 16,
                outlined: "",
                modelValue: (value.value as any),
                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (((value.value as any)) = $event)),
                label: fieldName.value
              }, null, 8, ["modelValue", "label"]))
            : _createCommentVNode("", true),
          (fieldType.value === 'FIELD_TIME')
            ? (_openBlock(), _createBlock(_component_q_time, {
                key: 17,
                modelValue: (value.value as any),
                "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (((value.value as any)) = $event))
              }, null, 8, ["modelValue"]))
            : _createCommentVNode("", true),
          (fieldType.value === 'FIELD_IMAGE_UPLOAD')
            ? (_openBlock(), _createBlock(PhotoUploader, {
                key: 18,
                "recap-field-instance-id": getFieldId(),
                "recap-field-instance-repeating-index": props.repeatingIndex,
                "file-count": fileCount.value,
                multiple: false,
                onAllFilesRemoved: allFilesRemoved,
                onFileAdded: fileAdded,
                ref_key: "singleImageUploader",
                ref: singleImageUploader
              }, null, 8, ["recap-field-instance-id", "recap-field-instance-repeating-index", "file-count"]))
            : _createCommentVNode("", true),
          (fieldType.value === 'FIELD_SIGNATURE_CAPTURE')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 19 }, [
                _createElementVNode("canvas", {
                  class: "tw-border-2",
                  ref_key: "signaturePad",
                  ref: signaturePad
                }, null, 512),
                _createElementVNode("div", _hoisted_19, [
                  _hoisted_20,
                  _createVNode(_component_q_btn, {
                    class: "tw-w-48 q-my-sm",
                    color: "red",
                    onClick: _unref(resetCanvas)
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Reset Signature")
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ])
              ], 64))
            : _createCommentVNode("", true),
          (fieldType.value === 'FIELD_DATETIME')
            ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                _createVNode(_component_q_date, {
                  modelValue: value.value,
                  "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((value).value = $event)),
                  mask: "YYYY-MM-DD HH:mm",
                  class: "q-mx-sm"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_q_time, {
                  modelValue: (value.value as any),
                  "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (((value.value as any)) = $event)),
                  mask: "YYYY-MM-DD HH:mm",
                  class: "q-mx-sm"
                }, null, 8, ["modelValue"])
              ]))
            : _createCommentVNode("", true),
          (fieldType.value === 'FIELD_DURATION')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 21 }, [
                _createElementVNode("div", _hoisted_22, [
                  _createVNode(_component_q_input, {
                    outlined: "",
                    modelValue: (value.value as any),
                    "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => (((value.value as any)) = $event)),
                    label: "Hours",
                    class: "q-mx-sm"
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_q_input, {
                    outlined: "",
                    modelValue: (secondValue.value as any),
                    "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => (((secondValue.value as any)) = $event)),
                    label: "Minutes",
                    class: "q-mx-sm"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("p", null, _toDisplayString(totalMinutes.value) + " minutes", 1)
              ], 64))
            : _createCommentVNode("", true),
          (fieldType.value === 'FIELD_AGREEMENT_CHECKBOX')
            ? (_openBlock(), _createBlock(_component_q_checkbox, {
                key: 22,
                modelValue: value.value,
                "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((value).value = $event)),
                label: fieldName.value
              }, null, 8, ["modelValue", "label"]))
            : _createCommentVNode("", true),
          (fieldType.value === 'FIELD_DISPLAY_TEXT')
            ? (_openBlock(), _createElementBlock("div", _hoisted_23, _toDisplayString(fieldName.value), 1))
            : _createCommentVNode("", true),
          (fieldType.value === 'FIELD_DISPLAY_IMAGE')
            ? (_openBlock(), _createElementBlock("img", _hoisted_24))
            : _createCommentVNode("", true),
          (fieldType.value === 'FIELD_IMAGE_UPLOAD_MULTIPLE')
            ? (_openBlock(), _createBlock(PhotoUploader, {
                key: 25,
                multiple: true,
                "recap-field-instance-id": getFieldId(),
                "recap-field-instance-repeating-index": props.repeatingIndex,
                onAllFilesRemoved: allFilesRemoved,
                onFileAdded: fileAdded,
                ref_key: "multiImageUploader",
                ref: multiImageUploader
              }, null, 8, ["recap-field-instance-id", "recap-field-instance-repeating-index"]))
            : _createCommentVNode("", true),
          (fieldType.value === 'FIELD_FORMULA')
            ? (_openBlock(), _createBlock(_component_q_input, {
                key: 26,
                outlined: "",
                disable: "",
                readonly: "",
                modelValue: (value.value as any),
                "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => (((value.value as any)) = $event)),
                label: fieldName.value
              }, null, 8, ["modelValue", "label"]))
            : _createCommentVNode("", true),
          (fieldType.value === 'FIELD_SELECT_WITH_NUMERIC_EQUIVALENT')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 27 }, [
                (filteredOptions.value.length < 7)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredOptions.value, (option) => {
                        return (_openBlock(), _createBlock(_component_q_radio, {
                          modelValue: (value.value as any),
                          "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => (((value.value as any)) = $event)),
                          val: option.numericEquivalent,
                          label: option.label,
                          key: `${_unref(recapType)}-${_unref(taskOrStoreId)}-${_ctx.field.id}-${option.value}`
                        }, null, 8, ["modelValue", "val", "label"]))
                      }), 128))
                    ]))
                  : (_openBlock(), _createBlock(_component_q_select, {
                      key: 1,
                      modelValue: value.value,
                      "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((value).value = $event)),
                      "option-label": "label",
                      "option-value": "numericEquivalent",
                      options: filteredOptions.value,
                      "emit-value": "",
                      "map-options": ""
                    }, null, 8, ["modelValue", "options"]))
              ], 64))
            : _createCommentVNode("", true),
          (fieldType.value === 'FIELD_RANK')
            ? (_openBlock(), _createBlock(_unref(Draggable), {
                key: 28,
                modelValue: filteredOptions.value,
                "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((filteredOptions).value = $event)),
                "item-key": "label"
              }, {
                item: _withCtx(({ element: option }) => [
                  _createElementVNode("div", _hoisted_26, _toDisplayString(option.label), 1)
                ]),
                _: 1
              }, 8, ["modelValue"]))
            : _createCommentVNode("", true),
          (fieldType.value === 'FIELD_DISPLAY_IMAGE' && _ctx.field.field.image)
            ? (_openBlock(), _createElementBlock("img", {
                key: 29,
                class: "tw-max-w-xl",
                src: _ctx.field.field.image
              }, null, 8, _hoisted_27))
            : _createCommentVNode("", true),
          (fieldNotes.value)
            ? (_openBlock(), _createElementBlock("small", _hoisted_28, _toDisplayString(fieldNotes.value), 1))
            : _createCommentVNode("", true),
          (fieldInfoText.value)
            ? (_openBlock(), _createElementBlock("div", {
                key: 31,
                onClick: _cache[29] || (_cache[29] = ($event: any) => (shouldDisplayInfoText.value = !shouldDisplayInfoText.value))
              }, [
                _hoisted_29,
                (shouldDisplayInfoText.value)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      innerHTML: fieldInfoText.value
                    }, null, 8, _hoisted_30))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (props.field.field.task_property === 'adsInstalled' && displayAdQuantity.value && adQuantity.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                _createElementVNode("em", null, "Expecting " + _toDisplayString(adQuantity.value), 1)
              ]))
            : _createCommentVNode("", true),
          (quantityReasonCodeError.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                _createElementVNode("em", _hoisted_33, _toDisplayString(quantityReasonCodeError.value), 1)
              ]))
            : _createCommentVNode("", true)
        ], 64))
  ], 512)), [
    [_vShow, 
      isVisible.value &&
      !_unref(shouldBeHidden) &&
      displayRaiReasonCodes.value &&
      displayAdQuantity.value &&
      displayQuantityReasonCode.value
    ]
  ])
}
}

})